export default __webpack_public_path__ + "assets/png/5ed925140d8697af7acea2b29537d946.png";